<template>
    <div style="padding:20px;">
        <Ckeditor :content="questionesData"></Ckeditor>
    </div>
</template>
<script>
    import Ckeditor from '@/components/ckeditor/ckeditorView'
    export default {
        name:"question_data",
        props:{
            questionesData:String
        },
        components:{
            Ckeditor
        }
    }
</script>
<style scoped>
    .tab-content-view {
        margin-top: 0;
    }
    .competition-detail-content .competition-detail-content-wrapper .tab-content-wrapper {
        -ms-flex: 1;
        flex: 1;
        width: 0;
    }
    .tab-content-wrapper {
        padding: 16px 24px 48px;
        min-height: 60vh;
    }
    .block-header {
        align-items: center;
        display: flex;
        min-height: 56px;
    }
    .markdown-body {
        -webkit-text-size-adjust: 100%;
        text-size-adjust: 100%;
        color: #333;
        line-height: 2;
        word-wrap: break-word;
    }
    .markdown-body p>img:last-child {
        margin-bottom: 0;
    }
    .markdown-body img {
        border: none;
        max-width: 100%;
        margin-top: 18px;
        margin-bottom: 18px;
    }
</style>
